<template>
  <vs-popup
    classContent="popup-example"
    :title="title"
    :active.sync="isOpen"
    class="popup-close small-popup"
    :button-close-hidden="true"
  >
    <div class="center">
      <img src="@/assets/images/pages/delete.svg" />
      <div class="success-msg">
        {{ $t("system.label.areYouSureDelete") }}
      </div>
    </div>
    <div class="center">
      <span class="p-2">
        <vs-button type="border" @click="$emit('onCancel')">{{
          $t("system.label.cancel")
        }}</vs-button></span
      >
      <span class="p-2">
        <vs-button @click="$emit('onConfirm')">{{
          $t("setup.label.Ok")
        }}</vs-button>
      </span>
    </div>
    <div style="height: 20px"></div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
